import { marked } from "marked";
import { FormGroup, ControlLabel } from "ui-components";

marked.setOptions({
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: true,
  smartLists: true,
  smartypants: false,
});

type Props = {
  ctrlLabel?: string;
  markdown?: string;
  className?: string;
  id: string;
};

const Markdown: React.FC<Props> = ({ id, markdown, ctrlLabel, className }) => {
  const html = marked(markdown || "", { renderer: new marked.Renderer() });

  return (
    <FormGroup controlId={`id_${id}`} className={className}>
      {ctrlLabel && <ControlLabel>{ctrlLabel}</ControlLabel>}
      {markdown && <div dangerouslySetInnerHTML={{ __html: html }} />}
    </FormGroup>
  );
};

export default Markdown;
